// extracted by mini-css-extract-plugin
export default {"device-authorize":"pxCVdU","deviceAuthorize":"pxCVdU","qrSlot":"cimRYa","qrWrapper":"yraqIX"};